var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prime:send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9417 3.05834C16.784 2.90181 16.5863 2.79177 16.3702 2.74032C16.1541 2.68886 15.928 2.69798 15.7167 2.76667L3.52502 6.83334C3.29891 6.90498 3.09911 7.04203 2.95084 7.22717C2.80258 7.4123 2.7125 7.63722 2.692 7.87352C2.67149 8.10982 2.72146 8.3469 2.83562 8.55481C2.94977 8.76272 3.12297 8.93214 3.33336 9.04167L8.39169 11.5417L10.8917 16.6167C10.9922 16.8153 11.1459 16.9821 11.3358 17.0984C11.5256 17.2146 11.7441 17.2758 11.9667 17.275H12.05C12.2884 17.2574 12.5161 17.1686 12.7033 17.02C12.8906 16.8714 13.0288 16.6699 13.1 16.4417L17.225 4.28334C17.2987 4.07328 17.3112 3.84662 17.261 3.62975C17.2108 3.41288 17.1001 3.21472 16.9417 3.05834ZM4.04169 7.98334L14.6834 4.43334L8.77502 10.3417L4.04169 7.98334ZM12.025 15.9583L9.65835 11.225L15.5667 5.31667L12.025 15.9583Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPlane);
export default __webpack_public_path__ + "static/media/send-plane.ef12f2f3c04964b1f7e18db8af79cf9d.svg";
export { ForwardRef as ReactComponent };